import { createContext, useContext } from "react";
import { LineType } from "src/routes/libraries/plan-package/takeoffs/components/AddItems/utils";

export type TakeoffsSidePanelMode =
  | { kind: "edit"; tliId: string }
  | { kind: "add"; type: LineType }
  | { kind: "duplicate"; tliId: string }
  | { kind: "bulkEdit" };

/** The modes `TakeoffLinePanel` shows a single line for */
export type SingleLinePanelMode = Exclude<TakeoffsSidePanelMode, { kind: "bulkEdit" }>;

export type TakeoffsSidePanelContextValue = {
  activeTliId: string | undefined;
  // Beam's `RightPanePanel` asks first when these would replace a panel that has unsaved changes
  openEdit: (tliId: string) => void;
  openAdd: (type: LineType) => void;
  openDuplicate: (tliId: string) => void;
  /** Bulk edits the table's selection */
  openBulkEdit: VoidFunction;
  /** Closes the open edit panel if it shows this line */
  lineDeleted: (tliId: string) => void;
  /** Called by the open edit panel to mark its line as active and close on its delete; returns a cleanup that unmarks it */
  registerShownLine: (tliId: string, onDeleted: VoidFunction) => VoidFunction;
};

export const TakeoffsSidePanelContext = createContext<TakeoffsSidePanelContextValue | undefined>(undefined);

export function useTakeoffsSidePanel(): TakeoffsSidePanelContextValue {
  const value = useContext(TakeoffsSidePanelContext);
  if (!value) throw new Error("Missing TakeoffsSidePanelProvider");
  return value;
}
